export default __webpack_public_path__ + "static/char-s-sp02-en-ba3ec3e015bd1e9b95eff5a6e1a2efe0.png";